<div class="header">
  {{ getCitiesStatesStreetsText() }} List
  <div class="close-icon">
    <img alt="" (click)="onClose()" src="../../../../../../assets/checkout-icons/x-black-icon.svg" />
  </div>
</div>
<div mat-dialog-content class="body2">
  <div class="title">
    <div class="title__font" [ngClass]="nativeCities == null ? 'display-none' : ''">
      Native Names @if (!showNativeCitiesV) {
      <img
        alt=""
        class="clipBoardImg"
        (click)="onHebrewCities()"
        [matTooltip]="'Click to copy all'"
        matTooltipClass="pdq-mat-tooltip"
        [cdkCopyToClipboard]="nativeCities"
        src="../../../../../../assets/checkout-icons/clipboard.svg" />
      } @if (showNativeCitiesV) {
      <img alt="" style="height: 14px" src="../../../../../../assets/checkout-icons/V.svg" />
      }
    </div>
    <div class="title__font">
      English names @if (!showEnglishCitiesV) {
      <img
        alt=""
        class="clipBoardImg"
        [matTooltip]="'Click to copy all'"
        matTooltipClass="pdq-mat-tooltip"
        (click)="onEnglishCities()"
        [cdkCopyToClipboard]="englishCities"
        src="../../../../../../assets/checkout-icons/clipboard.svg" />
      } @if (showEnglishCitiesV) {
      <img alt="" style="height: 14px" src="../../../../../../assets/checkout-icons/V.svg" />
      }
    </div>
  </div>
  @for (city of polygonCities; track city) {
  <div class="float-container">
    <div class="float-child" [ngClass]="nativeCities == null ? 'display-none' : ''">
      <div class="green">{{city.hebrew}}</div>
    </div>
    <div class="float-child">
      <div class="blue">{{city.english}}</div>
    </div>
  </div>
  }
</div>
